import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const formatPrice = (price, contract, lang = "it") => {
  if (!price || price <= 0) return lang === "it" ? "Prezzo su richiesta" : "Price on request";
  const formatter = new Intl.NumberFormat(lang === "it" ? "it-IT" : "en-GB", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });
  const formatted = formatter.format(price);
  return contract === "rent"
    ? `${formatted}${lang === "it" ? "/mese" : "/month"}`
    : formatted;
};
